import { OfferProps } from './types';

// The first purchase option is the default one. Links and buttons outside the plan cards have
// room for a single call to action, so they all point at it.
export const defaultRegistrationUrl = (offer: OfferProps) => (
  offer.purchaseOptions[0]?.registrationUrl
);
